/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React from 'react'
import { EllipseContainer, EllipseBadge } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { IconName } from '~/assets/icons'

export interface EllipseButtonProps {
  color: string
  quantity?: number
  iconName: IconName
  alert: boolean
}

export const EllipseButton = ({ color, quantity, iconName, alert }: EllipseButtonProps): JSX.Element => {
  const hasBadge = !!(quantity || alert)

  return (
    <EllipseContainer color={color}>
      <div data-testid="ellipse-background" className="background" />
      <IconComponent name={iconName} />

      {hasBadge && (
        <EllipseBadge color={color} isAltered={alert}>
          {quantity || '!'}
        </EllipseBadge>
      )}
    </EllipseContainer>
  )
}
